/* eslint-disable no-unused-vars */
import React, { useContext, useEffect, useState } from 'react';
import {
  Link, useNavigate, useParams, useSearchParams,
} from 'react-router-dom';
import { useDispatch } from 'react-redux';
import {
  Alert,
  Box, Button, Divider, Grid, LinearProgress, Snackbar,
} from '@mui/material';
import { DriveFileRenameOutlineOutlined } from '@mui/icons-material';
import moment from 'moment';
import AlertContext from '../../../../Context/AlertContext';
import Elements from '../../../Elements';
import { getAdminMarketItemDetails, updateMarketItem } from '../../../../Redux/Models/market';
import ROUTES from '../../../../Configs/routes';
import Images from '../../../../Configs/images';

export default function Component({
  selectedItem: data, classes, error, message, isLoading, newItem,
}) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { itemId } = useParams();
  const [param] = useSearchParams();
  const type = param.get('type') || 'item';

  const { box = {} } = data || {};

  const item = data.box || data.item || {};

  const { openAlert } = useContext(AlertContext);

  const [popUp, setPopUp] = useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
  const closeSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  useEffect(() => {
    if (error) {
      openAlert({
        message: `Something went wrong. ${message}`,
        severity: 'error',
      });
    }
  }, [error]);

  useEffect(() => {
    dispatch(getAdminMarketItemDetails(itemId, type));
  }, [itemId]);

  const handleToMarket = () => {
    const body = {
      item: {
        is_sale: !item?.is_sale,
        sale_type: item?.sale_type,
        category_id: item?.category_id,
        condition_id: item?.condition_id,
        digital_box_id: item?.digital_box_id,
        name: item?.name,
        description: item?.description,
        photo: item?.photo,
        volume: item?.volume,
        notes: item?.notes,
        price: item?.price,
      },
      box: box || item?.box_data,
    };
    if (itemId) {
      dispatch(updateMarketItem(itemId, body));
    }
  };

  useEffect(() => {
    if (newItem) {
      setSnackbar({
        open: true,
        severity: 'success',
        message: `Successfully ${!item?.is_sale ? ' sale item to market' : ' not sale item'}.`,
      });

      setTimeout(() => {
        navigate(ROUTES.market(), 'replace');
      }, 1000);
    }
  }, [newItem]);

  return (
    <Elements.AdminPageBase navigate={navigate}>
      <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={snackbar.open} autoHideDuration={10000} onClose={closeSnackbar}>
        <Alert onClose={closeSnackbar} severity={snackbar.severity || 'success'}>
          {snackbar.message}
        </Alert>
      </Snackbar>
      <div className={classes.root}>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Box fontSize={20}>
            <strong>OenoMarket</strong>
          </Box>
          <Box>
            <Link to="/" className="primary-green italic s-16">See Live View</Link>
          </Box>
        </Box>

        {isLoading && <LinearProgress color="inherit" sx={{ mt: 2 }} />}

        <Box mt={2} bgcolor="#FDFDFD" borderRadius="10px" p={2}>
          <Grid container spacing={3}>
            <Grid item xs={4}>
              <img src={item?.photo} alt="product" style={{ width: '100%', borderRadius: 24 }} />
            </Grid>
            <Grid item xs={8}>
              <Box display="flex" alignItems="center" justifyContent="space-between">
                <Box fontSize={18} fontWeight="700">{item.name}</Box>
                <Box display="flex" gap={1} alignItems="center" fontSize={12} className="primary-green link" onClick={() => navigate(`${ROUTES.market()}/update/${itemId}`)}>
                  <DriveFileRenameOutlineOutlined fontSize="small" />
                  Edit Information
                </Box>
              </Box>

              <Box display="flex" alignItems="center" justifyContent="space-between" mt={1}>
                <Box display="flex" alignItems="center" gap={1}>
                  <Box className="primary-green weight-700 s-18">
                    ₣
                    {item.price}
                  </Box>
                  <Box className="s-12">Highest bid</Box>
                </Box>
                <Box display="flex" alignItems="center" gap={1}>
                  <Box className="weight-600 s-14">
                    5
                  </Box>
                  <Box className="s-14">Watchers</Box>
                </Box>
              </Box>

              <Box display="flex">
                <Box flex={1}>
                  <Box mt={2}>
                    <Box className="s-14" fontWeight="400">Type</Box>
                    <Box mt={0.25} className="s-16" fontWeight="600">{item?.category_name}</Box>
                  </Box>
                  <Box mt={2}>
                    <Box className="s-14" fontWeight="400">Origin</Box>
                    <Box mt={0.25} className="s-16" fontWeight="600">French</Box>
                  </Box>
                  <Box mt={2}>
                    <Box className="s-14" fontWeight="400">Quantity</Box>
                    <Box mt={0.25} className="s-16" fontWeight="600">
                      1 Bottle
                    </Box>
                  </Box>
                </Box>
                <Box flex={1}>
                  <Box mt={2}>
                    <Box className="s-14" fontWeight="400">Condition</Box>
                    <Box mt={0.25} className="s-16" fontWeight="600">{item?.condition_name}</Box>
                  </Box>
                  <Box mt={2}>
                    <Box className="s-14" fontWeight="400">Volume</Box>
                    <Box mt={0.25} className="s-16" fontWeight="600">
                      {item?.volume || '0 mL'}
                    </Box>
                  </Box>
                  <Box mt={2}>
                    <Box className="s-14" fontWeight="400">In cellar since</Box>
                    <Box mt={0.25} className="s-16" fontWeight="600">{moment(item.marketed_on).format('DD MMM YYYY')}</Box>
                  </Box>
                </Box>
                <Box flex={1}>
                  <Box mt={2}>
                    <Box className="s-14" fontWeight="400">Year</Box>
                    <Box mt={0.25} className="s-16" fontWeight="600">2001</Box>
                  </Box>
                  <Box mt={2}>
                    <Box className="s-14" fontWeight="400">Alcohol% (AVB)</Box>
                    <Box mt={0.25} className="s-16" fontWeight="600">25%</Box>
                  </Box>
                </Box>
              </Box>

              <Divider sx={{ my: 2 }} />

              <Box display="flex">
                <Box flex={1}>
                  <Box className="s-14" fontWeight="400">Item ID</Box>
                  <Box mt={0.25} className="s-16" fontWeight="600">{item.id}</Box>
                </Box>
              </Box>

              <Divider sx={{ my: 2 }} />

              <Box display="flex">
                <Box flex={1}>
                  <Box className="s-14" fontWeight="400">Seller</Box>
                  <Box mt={0.25} className="s-16" fontWeight="600">{item.owner?.name || 'Admin'}</Box>
                </Box>
                <Box flex={1}>
                  <Box className="s-14" fontWeight="400">Member Since</Box>
                  <Box mt={0.25} className="s-16" fontWeight="600">{item.owner?.created_at || '-'}</Box>
                </Box>
                <Box flex={1}>
                  <Box className="s-14" fontWeight="400">Wine status</Box>
                  <Box mt={0.5}>
                    <Box display="inline-flex" alignItems="center" gap={0.5} bgcolor="#FDE0E0" borderRadius={8} pr={1}>
                      <img src={Images.CheckRed} alt="check-icon" />
                      <div className="s-10 weight-600">Verified</div>
                    </Box>
                  </Box>
                </Box>
              </Box>

              <Box display="flex" justifyContent="space-between" mt={2}>
                <Box flex={2}>
                  <Box className="s-14" fontWeight="400">Notes</Box>
                  <Box mt={0.25} className="s-16" fontWeight="600">{item.notes || '-'}</Box>
                </Box>
                <Box flex={1}>
                  <Box className="s-14" fontWeight="400">{item?.is_sale ? 'Sale In Market' : 'Not In Market'}</Box>
                  <Button sx={{ px: 6 }} variant="contained" className="action btn-contained" onClick={() => setPopUp(true)}>{!item?.is_sale ? 'Sale To Market' : 'Not Sale Item'}</Button>
                </Box>
              </Box>

            </Grid>
          </Grid>
        </Box>
      </div>
      <Elements.ConfirmationModal
        open={popUp}
        desc={(
          <div>
            Are you sure,
            {!item?.is_sale ? ' sale item to market' : ' not sale item'}
            ?
          </div>
        )}
        handleClose={() => setPopUp(false)}
        handleAgree={handleToMarket}
        isLoading={isLoading}
      />
    </Elements.AdminPageBase>
  );
}
